package us.laantech.admin.menu.clients.products

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.sizeIn
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import us.laantech.common.dto.RetailProductDTO
import us.laantech.common.ui.DropdownMenu
import kotlin.collections.set

@Composable
fun UploadProductsModal(viewModel: RetailProductsManagerViewModel) {
    /**
     * The user maps the source headers to the target headers
     */
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    val targetHeaders = remember {
        listOf(
            RetailProductDTO::title.name,
            RetailProductDTO::barcode.name,
            RetailProductDTO::priceCents.name,
            RetailProductDTO::ageLimit.name,
            "department",
            RetailProductDTO::ebt.name,
            RetailProductDTO::taxable.name,
            RetailProductDTO::userSku.name,
            )
    }
    val mapping = remember { mutableStateMapOf<String, String>() }
    val sourceHeaders = uiState.csv!!.listHeaders()

    Dialog(onDismissRequest = { viewModel.toggleShowUploadProductsModal() }) {
        Card(Modifier.sizeIn(minWidth = 300.dp, minHeight = 200.dp)) {

            Text(text = "Upload Products to ${uiState.companyBranch?.branchName}", modifier = Modifier.padding(8.dp))

            Column(Modifier.padding(8.dp)) {
                targetHeaders.forEach { target ->
                    Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                        Text(target, Modifier.weight(1f))

                        DropdownMenu(
                            target,
                            sourceHeaders,
                            mapping[target],
                            { it },
                            { mapping[target] = it ?: "" },
                            Modifier.weight(2f),
                            "Not Selected"
                        )

                        Text("TODO Preview data", Modifier.weight(1f))
                    }
                }
            }

            LinearProgressIndicator({
                uiState.numRowsProcessed.toFloat() / uiState.numRows.toFloat()
            }, Modifier.fillMaxWidth())

            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().padding(8.dp)
            ) {
                Text("Created ${uiState.numRowsProcessed} of ${uiState.numRows} products")
                Button({viewModel.createProducts(mapping)}) {
                    Text("Create Products")
                }
            }
        }
    }

}